import { createContext, useContext } from "react";

export type ToolCardLayoutMode = "compact" | "expanded";

interface ToolCardContextValue {
	mode: ToolCardLayoutMode;
}

const ToolCardContext = createContext<ToolCardContextValue>({ mode: "expanded" });

export const ToolCardContextProvider = ToolCardContext.Provider;

export function useToolCardContext() {
	return useContext(ToolCardContext);
}
